import ApiClientAmbassador from './apiClientAmbassador'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClient pre celú aplikáciu
const apiClientAmbassador = new ApiClientAmbassador()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientAmbassador.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClient`
useAuthStore.subscribe((state) => {
  apiClientAmbassador.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance.
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientAmbassador() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientAmbassador.setAuthToken(auth?.token ?? null)
  return apiClientAmbassador.apiInstance
}
